import { HostAppEventHandler } from "../manager/eventManager/HostAppEventHandler";
import { HostAppName } from "../office-js/HostAppSettings";
import { HostAppUtil } from "../office-js/HostAppUtil";
import { OneNoteEventHandler } from "../OneNote/OneNoteEventHandler";

export class HostAppEventHandlerFactory {
  private static _instance: HostAppEventHandler | null = null;

  static GetInstance() {
    if (this._instance == null) {
      switch (HostAppUtil.GetHostAppName()) {
        case HostAppName.ONENOTE:
          this._instance = new OneNoteEventHandler();
          break;
        default:
          this._instance = new HostAppEventHandler();
          break;
      }
    }
    return this._instance;
  }

  //Required for Unit test.
  static ResetInstance() {
    this._instance = null;
  }

  private constructor() { }
}